import React ,{ useState ,useRef,useEffect} from "react";
import { BCMSDate } from "@bcm-dev/bcms-vite";
import Month  from "../Month";
import PickerHeader from "../PickerHeader";
import PickerFooter from "../PickerFooter";

export default function SingleCalendar(props) {
    const [viewDate, setViewDate] = useState( BCMSDate.init(props.setDate).date);
    const [hoverDate, setHover] = useState( BCMSDate.init(props.setDate));
    const ref = useRef();
    const changeHover=function(date){
        if(date.isEqual(hoverDate) === false){          
            setHover(date);
        }
    }
    let month1 = BCMSDate.init(viewDate);
    let month2 = BCMSDate.init(viewDate).offset([0,1,0])  
    return(      
        <div className="date-picker">
            <div className="row"><PickerHeader month1={month1} month2={month2} setViewDate={setViewDate} leftDisabled={props.leftDisabled} rightDisabled={props.rightDisabled} /></div> 
            <div className='calendar-wrapper'>
                <Month viewDate={month1} setDate={props.setDate} setHover={changeHover} onChange={props.onChange} controllers={props.controllers} inputDate={props.inputDate}/>                
            </div>
            {/*<PickerFooter hoverDate={hoverDate} controllers={props.controllers}/>*/}
        </div>                
    )
} 